import styled from 'styled-components';
import { InputSpinnerProps } from '..';

type InputSpinnerWrapperProps = {
  size: InputSpinnerProps['size'];
};

export const InputSpinnerWrapper = styled.div<InputSpinnerWrapperProps>`
  --input-height: ${({ theme, size }) => theme.InputSpinner.sizes[size].height};
  height: var(--input-height);
  width: ${({ theme, size }) => theme.InputSpinner.sizes[size].width};
  display: grid;
  grid-template-columns: var(--input-height) 1fr var(--input-height);
  grid-template-rows: 1fr;
  gap: 0 0;
  grid-template-areas: '. . .';

  button:first-child {
    border-radius: 3px 0 0 3px;
    border-right: none;
  }

  button:last-child {
    border-radius: 0 3px 3px 0;
  }
`;

export const InputWrapper = styled.input`
  color: ${({ theme }) => theme.InputSpinner.input.color};
  border-width: 1px;
  border-color: ${({ theme }) => theme.InputSpinner.input.borderColor};
  border-style: solid;
  text-align: center;
  font-size: ${({ theme }) => theme.InputSpinner.input.fontSize};
  line-height: ${({ theme }) => theme.InputSpinner.input.lineHeight};
  width: calc(100%);
  padding: 2px 1px;
  appearance: none;
  border-radius: 0;
  margin: 0;
  font-weight: 400;
  background-color: ${({ theme }) => theme.InputSpinner.input.backgroundColor};

  &::-webkit-inner-spin-button {
    appearance: none;
  }

  &:focus {
    outline: none;
  }
`;

export const Button = styled.button`
  border-width: 1px;
  border-color: ${({ theme }) => theme.InputSpinner.button.borderColor};
  border-style: solid;
  color: ${({ theme }) => theme.InputSpinner.button.color};
  font-size: 24px;
  background-color: ${({ theme }) => theme.InputSpinner.button.backgroundColor};
  padding: 0;
  margin: 0;
  cursor: pointer;
  position: relative;
`;

export const Icon = styled.span`
  font-size: 16px;
  font-weight: 500;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
